webpackJsonp([121848987090403],{

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Section = __webpack_require__(34);
	
	var _Headers = __webpack_require__(24);
	
	var _CodeBlock = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = function () {
	  return React.createElement(
	    'div',
	    null,
	    React.createElement(
	      _Headers.PageHeader,
	      null,
	      'Test Support'
	    ),
	    React.createElement(
	      _Section.Section,
	      { alwaysExpanded: true, title: 'Testing Controllers' },
	      React.createElement(
	        'p',
	        null,
	        'Previously, we looked at using plugins to add application-level behavior. This presents us with a problem when we come to test components that depend on plugins.'
	      ),
	      React.createElement(
	        'p',
	        null,
	        'Let\u2019s take a look at the ControlPanel component that we built previously:'
	      ),
	      React.createElement(
	        _CodeBlock.CodeFile,
	        { path: 'src/components/ControlPanel.tsx' },
	        __webpack_require__(678)
	      ),
	      React.createElement(
	        'p',
	        null,
	        'As a slightly contrived example of a test, let\u2019s imagine that we want to verify that when the button is clicked, it dispatches the appropriate event.'
	      ),
	      React.createElement(
	        _CodeBlock.CodeFile,
	        { path: 'src/components/ControlPanel.test.before.tsx' },
	        __webpack_require__(676)
	      ),
	      React.createElement(
	        'p',
	        null,
	        'This test will throw an exception. The ControlPanel component is expecting to receive the EventManager instance from a plugin, but we haven\'t provided this plugin to the test case.'
	      ),
	      React.createElement(
	        'p',
	        null,
	        'Bright-js-framework provides the TestFixture class to help with this. Let\u2019s rewrite this test case using the TestFixture class to provide an EventManager to the test:'
	      ),
	      React.createElement(
	        _CodeBlock.CodeFile,
	        { path: 'src/components/ControlPanel.test.tsx' },
	        __webpack_require__(677)
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

	module.exports = "import * as React from 'react'\nimport { mount } from 'enzyme'\nimport { ControlPanel } from './ControlPanel'\n\ndescribe('ControlPanel', () => {\n  it('posts message when button is clicked', () => {\n    const dom = mount(<ControlPanel />)\n    dom.closest('button').simulate('click')\n  })\n})\n"

/***/ }),

/***/ 677:
/***/ (function(module, exports) {

	module.exports = "import * as React from 'react'\nimport { controllerTestFixture } from '@brightinteractive/bright-js-framework/test-utils'\nimport { ControlPanel } from './ControlPanel'\nimport EventManagerPlugin from '../plugins/EventManagerPlugin'\n\ndescribe('ControlPanel', () => {\n  it('posts message when button is clicked', async (done) => {\n    const fixture = await controllerTestFixture({\n      plugins: [EventManagerPlugin],\n      markup: (\n        <ControlPanel />\n      )\n    })\n\n    return new Promise((resolve) => {\n      fixture.getPlugin(EventManagerPlugin).eventManager.registerHandler('request-open-pod-bay-doors', () => {\n        done()\n      })\n    })\n  })\n})\n"

/***/ }),

/***/ 678:
/***/ (function(module, exports) {

	module.exports = "import * as React from 'react'\nimport { controller } from '@brightinteractive/bright-js-framework'\nimport { eventManager, EventManager } from '../plugins/EventManagerPlugin'\n\n@controller()\nexport class ControlPanel extends React.PureComponent {\n  @eventManager\n  eventManager: EventManager\n\n  handleOpenClick = () => {\n    this.eventManager.emit('request-open-pod-bay-doors')\n  }\n\n  componentDidMount() {\n    this.eventManager.registerHandler('request-open-pod-bay-doors', () => {\n      console.error('I’m sorry but I can’t do that, Dave')\n    })\n  }\n\n  render() {\n    return (\n      <div>\n        <h3>Pod Bay doors:</h3>\n        <button onClick={this.handleOpenClick}>Open</button>\n      </div>\n    )\n  }\n}\n"

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-docs-test-support-js-157e1ae28ee5be55e004.js